"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeopleAPI = void 0;
const base_1 = require("../base");
class PeopleAPI extends base_1.BaseAPI {
    /**
     * Get the primary person details by id.
     *
     * Supports append_to_response. Read more about this https://developers.themoviedb.org/3/getting-started/append-to-response.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-details
     */
    async details(personId, filters) {
        const path = this.getPath(`/person/${personId}`, filters);
        return this.get(path);
    }
    /**
     * Get the changes for a person. By default only the last 24 hours are returned.
     *
     * You can query up to 14 days in a single query by using the start_date and end_date query
     * parameters.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-changes
     */
    async changes(personId, filters) {
        const path = this.getPath(`/person/${personId}/changes`, filters);
        return this.get(path);
    }
    /**
     * Get the movie credits for a person.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-movie-credits
     */
    async movieCredits(personId, filters) {
        const path = this.getPath(`/person/${personId}/movie_credits`, filters);
        return this.get(path);
    }
    /**
     * Get the TV show credits for a person.
     *
     * You can query for some extra details about the credit with the https://developers.themoviedb.org/3/credits/get-credit-details.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-tv-credits
     */
    async tvCredits(personId, filters) {
        const path = this.getPath(`/person/${personId}/tv_credits`, filters);
        return this.get(path);
    }
    /**
     * Get the movie and TV credits together in a single response.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-combined-credits
     */
    async combinedCredits(personId, filters) {
        const path = this.getPath(`/person/${personId}/combined_credits`, filters);
        return this.get(path);
    }
    /**
     * Get the external ids for a person.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-external-ids
     */
    async externalIds(personId, filters) {
        const path = this.getPath(`/person/${personId}/external_ids`, filters);
        return this.get(path);
    }
    /**
     * Get the images for a person.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-images
     */
    async images(personId) {
        const path = this.getPath(`/person/${personId}/images`);
        return this.get(path);
    }
    /**
     * Get the images that this person has been tagged in.
     *
     * @see https://developers.themoviedb.org/3/people/get-tagged-images
     */
    async taggedImages(personId, filters) {
        const path = this.getPath(`/person/${personId}/tagged_images`, filters);
        return this.get(path);
    }
    /**
     * Get a list of translations that have been created for a person.
     *
     * @see https://developers.themoviedb.org/3/people/get-person-translations
     */
    async translations(personId, filters) {
        const path = this.getPath(`/person/${personId}/translations`, filters);
        return this.get(path);
    }
    /**
     * Get the most newly created person. This is a live response and will continuously change.
     *
     * @see https://developers.themoviedb.org/3/people/get-latest-person
     */
    async latest(filters) {
        const path = this.getPath('/person/latest', filters);
        return this.get(path);
    }
    /**
     * Get the list of popular people on TMDB. This list updates daily.
     *
     * @see https://developers.themoviedb.org/3/people/get-popular-people
     */
    async popular(filters) {
        const path = this.getPath('/person/popular', filters);
        return this.get(path);
    }
}
exports.PeopleAPI = PeopleAPI;
